import { Tooltip } from 'bootstrap';

/**
 * `v-bs-tooltip="text"` (optionally `v-bs-tooltip:top="text"`): a Bootstrap tooltip instead of a
 * native `title`.
 *
 * The native tooltip waits about a second, is often skipped by the browser, and never appears on a
 * disabled button — so help on a control that starts disabled (Save Decisions) was never seen. Put
 * this on a wrapper around a disabled button: the wrapper still receives the hover.
 *
 * Bootstrap 5.1 has no way to change a tooltip's text after creation, so the title is a function
 * that reads the latest bound value.
 */
export const bsTooltip = {
    mounted(el, binding) {
        el.__bsTipText = binding.value;
        el.__bsTip = new Tooltip(el, {
            title: () => el.__bsTipText || '',
            placement: binding.arg || 'bottom',
            trigger: 'hover focus',
            container: 'body',
            delay: { show: 150, hide: 0 },
        });
    },
    updated(el, binding) {
        el.__bsTipText = binding.value;
    },
    beforeUnmount(el) {
        if (el.__bsTip) el.__bsTip.dispose();
        el.__bsTip = null;
    },
};
